<i [class]="icon() + ' text-primary'"></i>
@if(!isCollapsed()) {
<span class="ml-3">{{ label() }}</span>
<i class="pi pi-angle-right ml-auto"></i>
}
